import rollbar from 'rollbar/dist/rollbar.umd'

if (['production', 'staging'].includes(process.env.NODE_ENV)) {
  window.Rollbar = rollbar.init(_rollbarConfig) // eslint-disable-line no-undef
}
